<div>
	<export-selector [type]="reportTypes.MASTERACCOUNT_AUDIT" 
		(cancel)="cancel()" 
		[logQueryBy]="logQueryBy"
		[(query)]="query"
		[(dateFilters)]="dateFilters"></export-selector>
</div>